<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <data-table :headings="depotDiscountGroupsHeadings" :data="depotDiscountGroups" :hasActions="true"
                            :pagingDetails="pagingDetails"
                            :stateChanged="filterStateChanged"
                            @pagingUpdated="onPagingUpdated"
                            @actionClicked="onCustomerDiscountGroupActionClicked" @filterSearchClicked="onFilterSearchClicked">
                    <template #actionButton>
                        <div class="w-100">
                            <button class="btn btn-primary" @click="onAddCustomerDiscountGroupClick">Add Customer Discount Group</button>
                        </div>
                    </template>
                    <template #filter>
                        <div class="p-3">
                            <div class="input-group pb-4">
                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="pb-4">
                                <label>Depots</label>
                                <bootstrap-select  :selectOptions="depots" :selectedOption="filter.depotId" :elementId="'depotFilterSelect'"
                                                   :returnSelectedOptionText="true"
                                                   @changeSelect="onDepotFilterSelect"></bootstrap-select>
                            </div>
                            <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                           :componentId="'customerDiscountGroupFilterRadioButtons'"
                                                           @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                        </div>
                    </template>
                </data-table>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="customerDiscountGroupMarkAsActiveInactiveModal.heading"
                :modalId="customerDiscountGroupMarkAsActiveInactiveModal.modalId"
                :isSaving="customerDiscountGroupMarkAsActiveInactiveModal.isSaving"
                :showModal="customerDiscountGroupMarkAsActiveInactiveModal.showModal"
                :isActive="customerDiscountGroupMarkAsActiveInactiveModal.isActive"
                @closeClicked="customerDiscountGroupMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="customerDiscountGroupAddEditFormModal.heading"
            :modalId="customerDiscountGroupAddEditFormModal.modalId"
            :isSaving="customerDiscountGroupAddEditFormModal.isSaving"
            :showModal="customerDiscountGroupAddEditFormModal.showModal"
            @closeClicked="onAddOrEditCustomerDiscountGroupModalCloseClick"
            @saveButtonClicked="onAddOrEditCustomerDiscountGroupSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="depotSelect">
                        Depot
                    </label>
                    <div class="text-danger" v-if="customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.hasError">
                        {{customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.errorMessage}}
                    </div>
                    <bootstrap-select  :selectOptions="depots" :selectedOption="customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.value" :elementId="'depotSelect'"
                                       :returnSelectedOptionText="true"
                                       @changeSelect="onDepotSelect"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label for="nameInput">
                        Name
                    </label>
                    <div class="text-danger" v-if="customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.hasError">
                        {{customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="nameInput" v-model="customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.value"/>
                </div>
                <div class="form-group">
                    <label for="discountAmountInput">
                        Discount Amount
                    </label>
                    <div class="text-danger" v-if="customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.hasError">
                        {{customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.errorMessage}}
                    </div>
                    <currency-input class="form-control" v-model="customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.value" 
                                    :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"></currency-input>
                    
                </div>
                <div class="form-group">
                    <label for="priceActiveDatePicker">
                        Date for Depot Discount Group to be active from
                    </label>
                    <div class="text-danger" v-if="customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.hasError">
                        {{customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.errorMessage}}
                    </div>
                    <date-picker aria-describedby="newPriceActiveDateHelp" :format="'DD/MM/YYYY'" :elementId="'priceActiveDatePicker'" 
                                 :date="customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.value"
                                 :initialiseDate="initialiseDate"
                                 @dateChange="onEffectiveDateSelected"></date-picker>
                    <small id="newPriceActiveDateHelp" class="form-text text-muted">
                        Enter the day new depot discount group will be active from
                    </small>
                </div>
            </form>
        </template>
    </modal-form>
    
    <link-products-to-customer-depot-discount-group-modal
            :heading="linkProductsToDiscountGroupModal.heading"
            :modalId="linkProductsToDiscountGroupModal.modalId"
            :showModal="linkProductsToDiscountGroupModal.showModal"
            :customerDiscountGroupId="linkProductsToDiscountGroupModal.customerDiscountGroupId"
            :depotId="linkProductsToDiscountGroupModal.depotId"
            @okClicked="onLinkProductsToCustomerGroupModalOkClick"></link-products-to-customer-depot-discount-group-modal>
</div>
